import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';

type GetWatchlistResponse = {
  name: string,
  graduation: {
    month: number,
    year: number,
  }
}

type WatchlistAction = {
  isLastPage: boolean,
  type: string,
  response: {
    results: Array<GetWatchlistResponse>
  },
}

const initialState = {};

export default function reduceWatchlist(state = initialState, action: WatchlistAction) {
  if (!action.type) {
    return state;
  }

  const actionGroup: string = getActionGroup(action?.type);

  switch (action?.type) {
  case ActionTypes.watchlist.get.START:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...state[actionGroup],
          fetching: true,
          success: false,
          error: null,
        },
      },
    };
  case ActionTypes.watchlist.add.START:
    return {
      ...state,
      GET_WATCHLIST_API: {
        ...(state?.GET_WATCHLIST_API || {}),
        fetching: true,
        success: false,
        error: null,
      },
      ...{
        [actionGroup]: {
          fetching: true,
          success: false,
          error: null,
        },
      },
    };

  case ActionTypes.watchlist.remove.START:
    return {
      ...state,
      ...{
        [actionGroup]: {
          fetching: true,
          success: false,
          error: null,
        },
      },
    };
  case ActionTypes.watchlist.get.SUCCESS:
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] ?? {}),
        ...(action?.response ?? {}),
        results:
          action?.response?.page > 0
            ? (state[actionGroup] || {})?.results.concat(action?.response?.results ?? [])
            : action?.response?.results,
        fetching: false,
        success: true,
        error: null,
      },
    };

  case ActionTypes.watchlist.add.SUCCESS: {
    return {
      ...state,
      GET_WATCHLIST_API: {
        ...(state?.GET_WATCHLIST_API || {}),
        watchedUserIds: [...state?.GET_WATCHLIST_API?.watchedUserIds ?? [], action?.userInfo?._id],
      },
      [actionGroup]: {
        fetching: false,
        success: true,
        error: null,
      },
    };
  }
  case ActionTypes.watchlist.remove.SUCCESS:
    return {
      ...state,
      GET_WATCHLIST_API: {
        ...(state?.GET_WATCHLIST_API || {}),
        results: (state?.GET_WATCHLIST_API?.results ?? []).filter(
          (talent) => talent?._id !== action?.userInfo?._id,
        ),
        watchedUserIds: (state?.GET_WATCHLIST_API?.watchedUserIds ?? []).filter(
          (id) => id !== action?.userInfo?._id,
        ),
      },
      [actionGroup]: {
        fetching: false,
        success: true,
        error: null,
      },

    };

  case ActionTypes.watchlist.clearRemove:
    return {
      ...state,
      REMOVE_FROM_WATCHLIST_API: {},
    };

  case ActionTypes.watchlist.clearAdd:
    return {
      ...state,
      ADD_TO_WATCHLIST_API: {},
    };

  case ActionTypes.watchlist.get.ERROR:
  case ActionTypes.watchlist.add.ERROR:
  case ActionTypes.watchlist.remove.ERROR:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          success: false,
          fetching: false,
          error: action?.error,
        },
      },
    };

  default:
    return state;
  }
}
